import Head from "next/head";
import TabBar from "../../components/Cart/TabBar";
import TableProduct from "../../components/Cart/TableProduct";
import Invoice from "../../components/Cart/Invoice";
import Delivery from "../../components/Cart/Delivery";
import LayoutPayment from "../../components/layout/LayoutPayment";
import PaymentContext from "../../store/PaymentContext";
import EmptyCart from "../../components/Cart/EmptyCart";
import Payment from "../../components/Cart/Payment";
import { useContext, useEffect } from "react";
import { PaymentConst } from "../../utils/payment";
import ModalCustomer from "../../components/Cart/ModalCustomer";
import { Spin } from "antd";
import { GetStaticProps } from "next";
import PaymentSuccess from "../../components/Cart/PaymentSuccess";
import { ICustomerAppContext } from "../../@types/IContext/IPaymentContext";

export const getStaticProps: GetStaticProps<any> = async (
    context: any
) => {

    return {
        props: {},
    }
}

const Carts = () => {

    const {
        currentStep,
        sellCarts,
        rentCarts,
        tabActiveStep1,
        spinLoading,
        setSpinLoading,
        isMobile,
        sellCustomer,
        setSellCustomer,
        setTabActiveStep1
    } = useContext(PaymentContext);


    let carts = Number(tabActiveStep1) === Number(PaymentConst.TabConst.rent) ? rentCarts : sellCarts;


    useEffect(() => {
        const timeOutRef = setTimeout(() => {
            setSpinLoading(false)
        }, 500)
        setTabActiveStep1(localStorage.getItem("tabActiveStep1") ?? 1)
        if (sellCustomer?.sex === null || sellCustomer?.sex === undefined || sellCustomer?.sex === '') {
            setSellCustomer((pre: ICustomerAppContext) => ({
                ...pre,
                sex: 0,
            }))
        }
        if (!localStorage.getItem("tabActiveStep1")) {
            if (sellCarts?.length === 0 && rentCarts?.length > 0) {
                setTabActiveStep1(1);
            } else if (sellCarts?.length > 0 && rentCarts?.length === 0) {
                setTabActiveStep1(2);
            } else {
                setTabActiveStep1(tabActiveStep1 ?? 1);
            }
        }


        return () => {
            clearTimeout(timeOutRef);
        }
    }, [])


    const renderStep = () => {
        switch (currentStep) {
            case 1:
                return (
                    <>
                        <div className="carts pb-4">
                            <TabBar isShowTab={true} />
                            <div className="m-auto flex flex-col md:gap-4 px-4">
                                {
                                    carts?.length > 0 ? (
                                        <div className="grid grid-cols-1 gap-4 sm:grid-cols-4">
                                            <div className={`sm:col-span-2 md:col-span-2 lg:col-span-3 carts__left-content ${isMobile ? '' : 'mt-4'}`}>
                                                <div className="carts__left-content">
                                                    <div className="cart-products">
                                                        <TableProduct />
                                                    </div>
                                                    <Delivery />
                                                </div>
                                            </div>
                                            <div className={`sm:col-span-2 md:col-span-2 lg:col-span-1 ${isMobile ? '' : 'mt-4'}`}>
                                                <Invoice />
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="">
                                            <div className="cart-box rounded grid flex items-center justify-center text-lg mt-4">
                                                Không có thông tin bán
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </div>
                        {/*<TotalCart setLoading={setLoading} />*/}
                    </>
                )

            case 2:
                return (
                    <>
                        <div className="carts pb-4">
                            <TabBar isShowTab={false} />
                            <Payment setLoading={setSpinLoading} />
                        </div>
                    </>
                )

            case 3:
                return (
                    <>
                        <div className="carts pb-6">
                            <PaymentSuccess />
                        </div>
                    </>
                )
        }
    }

    return (
        <>
            <Head>
                <title>Giỏ hàng</title>
                <meta name="description" content="Generated by create next app" />
                <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
                <link rel="icon" href="/favicon.ico" />
            </Head>
            <div
                style={{
                    height: '100vh',
                    position: 'relative',
                    left: 0,
                    right: 0,
                    backgroundImage: `url("../asset/image/background_cart.png")`,
                    backgroundSize: '100% 100%',
                    backgroundRepeat: 'no-repeat',
                    overflow: 'hidden'
                }}
            >
                <LayoutPayment className="md:px-4 md:pt-4">
                    <Spin spinning={spinLoading}>
                        {
                            (sellCarts?.length > 0 || rentCarts?.length > 0) ? (
                                <div className="" style={{ backgroundColor: ' rgba(255, 255, 255, 0.3)' }}>
                                    {/*<ModalCustomer />*/}
                                    {
                                        renderStep()
                                    }
                                </div>
                            ) : (
                                <div className="overflow-hidden" style={{ backgroundColor: ' rgba(255, 255, 255, 0.3)', height: 'calc(100vh - 6rem)' }} >
                                    <EmptyCart />
                                </div>
                            )
                        }
                    </Spin>

                </LayoutPayment>
            </div>
        </>
    )
}

export default Carts;
